import { render } from "./CursorEffectComponent.vue?vue&type=template&id=7e21df18"
import script from "./CursorEffectComponent.vue?vue&type=script&lang=js"
export * from "./CursorEffectComponent.vue?vue&type=script&lang=js"

import "./CursorEffectComponent.vue?vue&type=style&index=0&id=7e21df18&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__